import { generateUnOrderedList, getCircleTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc62 = {
    title: "Image 62: Examples of Compact Storage System at the Record Room in the Bhadrak District Court, Odisha.",
    para1: <>
        <p>There are two images of the compactor storage system used in the Bhadrak District Court. Compactor storage rooms are designed to maximize storage capacity by using movable shelving systems on tracks, which glide to create a single access aisle when needed. </p>
        <p>The image on the left shows the compactor storage system when they are closed. Each of the movable storage compartments has been labelled with the kind of cases that are stored in that shelf. </p>
        <p>
            The image on the right shows the compactor storage system when it has been opened. The image shows a partial view of the shelves within the compartments with the files in them. The compartments are labelled and one of the compartments also has a picture of a deity.
        </p>
    </>,
}

export const FigureDesc53 = {
    title: "Figure 53: Typical floor plan of a Record Room.",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The features of the space are described in a clockwise manner, starting from the entrance at the bottom left of the plan.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The entrance to the record room is on the bottom left corner of the floor plan. The entrance is access-controlled and equipped with CCTV facilities.",
                    "Upon entering, a small room is provided for the staff receiving the records to be stored.",
                    "A table is provided to the right of this room, with provision of digital technology and a chair for the staff. Drinking water is provided next to the desk. CCTV facilities are provided at the top-right corner.",
                    <>
                        Office for record room staff:
                        {getCircleTypeListItem([
                            "A door is provided at the top-left corner towards the office space for the record room staff (3500 mm x 4750 mm).",
                            "Four workstations are provided in total, with two at the top and two at the bottom of the office space. These desks are equipped with digital technology and include provision for accessible seating, with a turning diameter of 1500 mm. ",
                            "A table for keeping records is provided at the right side of the office space.",
                            "CCTV facilities are provided at the top-right corner.",

                        ])}
                    </>,
                    <>
                        Record room:
                        {getCircleTypeListItem([
                            "Through a door provided at the top-left corner of the office space, the record room can be accessed.",
                            "Compact Storage Systems are arranged in a systematic manner for easy storage and archival of records. A total of five such arrangements of filing shelves have been depicted - one is provided at the top-left corner of the layout, and the other four are organised in the centre of the record room space, adjacent to the office spaces for the staff.",
                            "Adequate space is provided for movement across the room and in-between the storage shelves, with a turning diameter of 1500 mm for wheelchair accessibility.",
                            "CCTV facilities are provided in the four corners of the space.",

                        ])}
                    </>

                ])}
            </div>
        </p>
    </>
}

